import { createFomoSectionTransition } from "./sectionMotion";
import { createFomoBenefits } from "./benefitsMotion";
import { createFomoDecision } from "./decisionMotion";
import { createMotionScope } from "./motionScope";
export function mountLaunchMotion(root) {
  const { listen, animate, observeSize, observeReveal, frame, delay, dispose } =
    createMotionScope();
  root.classList.add("js");
  const $ = (s) => root.querySelector(s),
    $$ = (s) => [...root.querySelectorAll(s)];
  const clamp = (x, min = 0, max = 1) => Math.max(min, Math.min(max, x));
  const lerp = (a, b, p) => a + (b - a) * p;
  const ease = (p) => p * p * (3 - 2 * p);
  const media = matchMedia("(prefers-reduced-motion: reduce)");
  const track = $(".story-track"),
    theatre = $(".product-theatre"),
    pass = $("#journey-pass");
  const videos = $$("video");
  let paused = media.matches,
    chapter = -1,
    phase = 0,
    manualChapter = 0,
    framePending = false,
    scanOverride = false,
    scanTimeout,
    scanning = false;
  const benefitExperience = createFomoBenefits({
    root,
    listen,
    observeSize,
    isPaused: () => paused,
    isReduced: () => media.matches,
    requestUpdate,
  });
  const decisionExperience = createFomoDecision({
    root,
    listen,
    animate,
    isPaused: () => paused,
    isReduced: () => media.matches,
    requestUpdate,
  });
  const sectionExperience = createFomoSectionTransition({
    frame: $(".story-frame"),
    sticky: $(".story-sticky"),
    incoming: $(".benefit-sticky"),
    header: $(".site-header"),
    isStill: () => paused || media.matches,
  });
  const keys = [
    {
      t: 0,
      x: 0.06,
      y: 0.08,
      s: 0.68,
      r: -18,
      ry: -28,
      o: 1,
    },
    {
      t: 0.14,
      x: 0.02,
      y: -0.02,
      s: 1.14,
      r: 3,
      ry: 9,
      o: 1,
    },
    {
      t: 0.2,
      x: 0,
      y: -0.025,
      s: 1.1,
      r: -3,
      ry: -5,
      o: 1,
    },
    {
      t: 0.29,
      x: -0.4,
      y: 0.2,
      s: 0.35,
      r: -12,
      ry: -8,
      o: 0.9,
    },
    {
      t: 0.46,
      x: -0.4,
      y: 0.23,
      s: 0.34,
      r: -8,
      ry: 0,
      o: 0.85,
    },
    {
      t: 0.53,
      x: 0.3,
      y: 0.25,
      s: 0.3,
      r: 12,
      ry: 0,
      o: 0,
    },
    {
      t: 0.7,
      x: 0.3,
      y: 0.25,
      s: 0.3,
      r: 12,
      ry: 0,
      o: 0,
    },
    {
      t: 0.78,
      x: 0.03,
      y: -0.11,
      s: 0.55,
      r: 5,
      ry: -18,
      o: 1,
    },
    {
      t: 0.94,
      x: 0.03,
      y: -0.11,
      s: 1.04,
      r: 0,
      ry: 0,
      o: 1,
    },
    {
      t: 1,
      x: 0.03,
      y: -0.11,
      s: 1.08,
      r: 0,
      ry: 0,
      o: 1,
    },
  ];
  function interpolate(p) {
    let a = keys[0],
      b = keys[keys.length - 1];
    for (let i = 1; i < keys.length; i++) {
      if (p <= keys[i].t) {
        a = keys[i - 1];
        b = keys[i];
        break;
      }
    }
    const q = ease(clamp((p - a.t) / (b.t - a.t)));
    return Object.fromEntries(
      ["x", "y", "s", "r", "ry", "o"].map((k) => [k, lerp(a[k], b[k], q)])
    );
  }
  function setChapter(next) {
    if (next === chapter) return;
    chapter = next;
    theatre.dataset.scene = String(next);
    $("#scene-count").textContent = String(next + 1).padStart(2, "0");
    $$("[data-copy]").forEach((el) => {
      const active = Number(el.dataset.copy) === next;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-hidden", String(!active));
      el.inert = !active;
    });
    $$("[data-layer]").forEach((el) => {
      const active = Number(el.dataset.layer) === next;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-hidden", String(!active));
      el.inert = !active;
    });
    $$("[data-chapter]").forEach((el) =>
      el.setAttribute(
        "aria-pressed",
        String(Number(el.dataset.chapter) === next)
      )
    );
  }
  function update() {
    framePending = false;
    const viewport = innerHeight;
    const headerHeight = $(".site-header").offsetHeight;
    const top = track.getBoundingClientRect().top + scrollY;
    const length =
      track.offsetHeight -
      Math.max(viewport - headerHeight, $(".story-sticky").offsetHeight);
    let p = media.matches
      ? (manualChapter + 0.7) / 4
      : clamp((scrollY - top + headerHeight) / Math.max(length, 1));
    const raw = p * 4,
      next = Math.min(3, Math.floor(raw));
    phase = raw >= 4 ? 1 : raw - next;
    if (media.matches || paused) phase = 0.85;
    sectionExperience.prepare(next);
    setChapter(next);
    const stepPhase = ease(clamp(phase / 0.75));
    theatre.style.setProperty("--phase", stepPhase.toFixed(3));

    theatre.style.setProperty(
      "--foil-shift",
      (-50 + stepPhase * 100).toFixed(2) + "%"
    );
    theatre.style.setProperty(
      "--qr-focus",
      next === 3 ? ease(clamp((phase - 0.5) / 0.36)).toFixed(3) : "0"
    );
    const localProgress = paused || media.matches ? (next + 0.77) / 4 : p;
    const transform = interpolate(localProgress);
    pass.style.transform = `translate(-50%,-50%) translate(${
      transform.x * theatre.clientWidth
    }px,${transform.y * theatre.clientHeight}px) scale(${transform.s}) rotate(${
      transform.r
    }deg) rotateY(${transform.ry}deg)`;
    pass.style.opacity = transform.o.toFixed(3);
    const scan = clamp((phase - 0.1) / 0.66),
      valid = scanOverride ? 1 : ease(clamp((phase - 0.64) / 0.22));
    theatre.style.setProperty("--scan", scan.toFixed(3));
    theatre.style.setProperty("--valid", valid.toFixed(3));
    theatre.style.setProperty(
      "--scan-opacity",
      scanOverride || phase > 0.84 ? "0" : "1"
    );
    if (!scanning) {
      $("#access-title").textContent =
        valid > 0.7 ? "Acceso validado" : "Entrada reconocida";
    }
    $(".story-sticky").style.setProperty(
      "--chapter-progress",
      phase.toFixed(3)
    );
    const heroProgress = clamp(scrollY / $(".hero").offsetHeight);
    root.style.setProperty(
      "--hero-scroll",
      paused ? "0" : heroProgress.toFixed(3)
    );
    const reading = clamp(
      scrollY / Math.max(1, document.documentElement.scrollHeight - viewport)
    );
    $(".site-header").style.setProperty("--read", reading.toFixed(4));
    $(".site-header").classList.toggle("scrolled", scrollY > 30);
    sectionExperience.update(phase);
    benefitExperience.update();
    const money = $(".money-section").getBoundingClientRect();
    const moneyProgress =
      paused || media.matches
        ? 1
        : ease(
            clamp(
              (viewport - money.top - viewport * 0.12) /
                (Math.min(money.height, viewport) * 0.78)
            )
          );
    root.style.setProperty("--money", moneyProgress.toFixed(3));
    decisionExperience.update(moneyProgress.toFixed(3));
    const closing = $(".closing").getBoundingClientRect();
    root.style.setProperty(
      "--closing",
      paused || media.matches
        ? "1"
        : clamp((viewport - closing.top) / (viewport + closing.height)).toFixed(
            3
          )
    );
  }
  function requestUpdate() {
    if (!framePending) {
      framePending = true;
      frame(update);
    }
  }
  listen(window, "scroll", requestUpdate, {
    passive: true,
  });
  listen(window, "resize", requestUpdate, {
    passive: true,
  });
  observeSize(track, requestUpdate);
  observeSize(theatre, requestUpdate);
  const reveal = observeReveal(
    (entries) =>
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          reveal.unobserve(entry.target);
        }
      }),
    {
      threshold: 0.12,
    }
  );
  $$("[data-reveal]").forEach((el) => reveal.observe(el));
  function gotoChapter(index) {
    manualChapter = clamp(index, 0, 3);
    if (media.matches) {
      update();
      track.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
      return;
    }
    const headerHeight = $(".site-header").offsetHeight,
      top = track.getBoundingClientRect().top + scrollY;
    const length = track.offsetHeight - $(".story-sticky").offsetHeight;
    window.scrollTo({
      top: top - headerHeight + length * ((manualChapter + 0.45) / 4),
      behavior: paused ? "auto" : "smooth",
    });
  }
  $$("[data-chapter]").forEach((button) =>
    listen(button, "click", () => gotoChapter(Number(button.dataset.chapter)))
  );
  $$("[data-go-scene]").forEach((link) =>
    listen(link, "click", (event) => {
      event.preventDefault();
      gotoChapter(Number(link.dataset.goScene));
    })
  );
  $$("[data-tour]").forEach((button) =>
    listen(button, "click", () => gotoChapter(0))
  );
  const zones = {
    pista: "Pista general",
    mesas: "Mesas VIP",
    gradas: "Gradas",
  };
  function selectZone(zone) {
    $("#selected-zone").textContent = zones[zone];
    $("#journey-zone").textContent = zones[zone];
    $("#access-detail").textContent =
      "AFTER HOURS · " + zones[zone] + " · Demo";
    $$("[data-zone]").forEach((button) =>
      button.setAttribute("aria-pressed", String(button.dataset.zone === zone))
    );
    $$("[data-map-zone]").forEach((el) => {
      const selected = el.dataset.mapZone === zone;
      el.style.opacity = selected ? "1" : ".46";
      el.classList.toggle("is-selected", selected);
    });
  }
  $$("[data-zone]").forEach((button) =>
    listen(button, "click", () => selectZone(button.dataset.zone))
  );
  const sales = {
    preventa: [42, 27, 15],
    general: [31, 19, 12],
  };
  $$("[data-sale]").forEach((button) =>
    listen(button, "click", () => {
      const values = sales[button.dataset.sale],
        total = values.reduce((a, b) => a + b, 0);
      $("#sales-count").textContent = total;
      $("#sales-revenue").textContent =
        "$" +
        (total * (button.dataset.sale === "preventa" ? 15 : 25)).toLocaleString(
          "es-EC"
        );
      $("#sales-occupancy").textContent = Math.round((total / 120) * 100) + "%";
      $$("[data-sale]").forEach((el) =>
        el.setAttribute("aria-pressed", String(el === button))
      );
      $$(".sales-row").forEach((row, index) => {
        row.querySelector("b").textContent = values[index];
        row
          .querySelector("i")
          .style.setProperty("--bar", values[index] * 2 + "%");
      });
    })
  );
  listen($("#scan-demo"), "click", () => {
    const button = $("#scan-demo");
    clearTimeout(scanTimeout);
    scanOverride = false;
    scanning = true;
    button.disabled = true;
    $("#access-title").textContent = "Validando QR…";
    theatre.style.setProperty("--valid", "0");
    const line = $(".scanner-line");
    line.style.opacity = "1";
    const duration = paused || media.matches ? 0 : 950;
    const anim = animate(
      line,
      [
        {
          top: "18%",
        },
        {
          top: "76%",
        },
      ],
      {
        duration,
        easing: "ease-in-out",
      }
    );
    scanTimeout = delay(() => {
      anim.cancel();
      line.style.opacity = "";
      scanOverride = true;
      scanning = false;
      button.disabled = false;
      button.querySelector("span").textContent = "Repetir escaneo";
      update();
    }, duration);
  });
  function applyMotion() {
    root.classList.toggle("motion-paused", paused);
    $("#motion-control").setAttribute("aria-pressed", String(paused));
    $("#motion-control").setAttribute(
      "aria-label",
      paused ? "Activar movimiento" : "Pausar movimiento"
    );
    const icon = $("#motion-control i");
    icon.className = paused ? "fas fa-play" : "fas fa-pause";
    videos.forEach((video) => {
      if (paused) video.pause();
      else video.play().catch(() => {});
    });
    requestUpdate();
  }
  listen($("#motion-control"), "click", () => {
    paused = !paused;
    applyMotion();
  });
  listen(media, "change", () => {
    paused = media.matches;
    applyMotion();
  });
  const heroObject = $("#hero-object"),
    heroPass = $(".hero-pass");
  listen(heroPass, "animationend", () => (heroPass.style.animation = "none"), {
    once: true,
  });
  listen(heroObject, "pointermove", (event) => {
    if (paused || media.matches || event.pointerType === "touch") return;
    const rect = heroObject.getBoundingClientRect(),
      x = (event.clientX - rect.left) / rect.width - 0.5,
      y = (event.clientY - rect.top) / rect.height - 0.5;
    heroPass.style.transform = `rotate(${-10 + x * 8}deg) rotateY(${
      -18 + x * 24
    }deg) rotateX(${7 - y * 12}deg) translateY(12px)`;
  });
  listen(heroObject, "pointerleave", () => (heroPass.style.transform = ""));
  listen($("[data-money-faq]"), "click", () => ($("#faq-money").open = true));
  listen(document, "visibilitychange", () => {
    videos.forEach((video) =>
      document.hidden || paused ? video.pause() : video.play().catch(() => {})
    );
  });
  listen(root, "click", (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (
      !link ||
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    const target = root.querySelector(link.getAttribute("href"));
    if (target) {
      event.preventDefault();
      target.scrollIntoView({
        behavior: paused || media.matches ? "instant" : "smooth",
      });
    }
  });
  selectZone("pista");
  applyMotion();
  update();
  root.dataset.ready = "true";
  return () => {
    videos.forEach((video) => video.pause());
    sectionExperience.destroy();
    dispose();
  };
}
